import { render, staticRenderFns } from "./VisaTypeFeeBlock.vue?vue&type=template&id=0603276d"
import script from "./VisaTypeFeeBlock.vue?vue&type=script&lang=js"
export * from "./VisaTypeFeeBlock.vue?vue&type=script&lang=js"
import style0 from "./VisaTypeFeeBlock.vue?vue&type=style&index=0&id=0603276d&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports